export default __webpack_public_path__ + "static/core2-3c0ed4d915af7d35c8756aedaab09a09.jpg";